import * as React from 'react';

import { cn } from '../../lib/utils';

const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'h-[34px] px-[10px] py-[7px] rounded-[4px]',
      'bg-white border border-[#e0e0e0]',
      'text-[14px] text-[#030303] placeholder:text-[#999999]',
      'focus:outline-none focus:border-[#0265ff] focus:ring-0',
      'disabled:bg-[#eff0f6] disabled:cursor-not-allowed disabled:opacity-100',
      'dark:bg-background dark:border-border dark:text-foreground dark:placeholder:text-muted-foreground',
      'dark:disabled:bg-[oklch(0.279_0.041_260.031)]',
      'w-full',
      className
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
